import React from "react";
import classes from "./termsAndConditions.module.css";
import Footer from "../../components/footer";

const TermsAndConditions = () => {
  return (
    <>
      <div className={classes.policyContainer}>
        <div className={classes.policyWrapper}>
          <h1>Terms & Conditions</h1>

          <h2>Payment Terms</h2>
          <ul>
            <li>Payments are processed securely through Razorpay.</li>
            <li>Users must complete payment to confirm bookings.</li>
          </ul>

          <h2>User Responsibilities</h2>
          <ul>
            <li>Users agree to provide accurate information when booking.</li>
            <li>Artists must fulfil accepted bookings as per agreed terms.</li>
          </ul>

          <h2>Dispute Resolution</h2>
          <ul>
            <li>
              Disputes related to payments or services will be reviewed by
              Artist Next Door's support team.
            </li>
          </ul>

          <h2>Intellectual Property</h2>
          <ul>
            <li>
              All content on the platform belongs to Artist Next Door and may
              not be reused without permission.
            </li>
          </ul>

          <h2>Governing Law</h2>
          <ul>
            <li>These terms are governed by the laws of India.</li>
          </ul>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default TermsAndConditions;
